// extracted by mini-css-extract-plugin
export default {"root":"E5RSMi","text":"QPn7O3","icon":"B34hTB"};